import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2）。/chat 配下は 3 ペインのレイアウト（ChatLayout）の子 */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const chatRoutes: RouteObject[] = [
  {
    path: '/chat',
    lazy: page(() => import('./pages/ChatLayout.js')),
    children: [
      { index: true, lazy: page(() => import('./pages/ChatHomePage.js')) },
      { path: 'dms', lazy: page(() => import('./pages/DmHomePage.js')) },
      { path: 'channel', lazy: page(() => import('./pages/ChannelHomePage.js')) },
      { path: 'c/:id', lazy: page(() => import('./pages/ChatConversationPage.js')) },
      // サイドバー最上部の「自分宛て」（§12.10.2）。材料は conversation の GET /conversation/me/inbox
      { path: 'inbox', lazy: page(() => import('./pages/ChatInboxPage.js')) },
      { path: 'threads', lazy: page(() => import('./pages/ThreadsPage.js')) },
      { path: 'saved', lazy: page(() => import('./pages/SavedPage.js')) },
      { path: 'search', lazy: page(() => import('./pages/SearchPage.js')) },
      { path: 'channels', lazy: page(() => import('./pages/ChannelsPage.js')) },
      { path: 'settings', lazy: page(() => import('./pages/ChatSettingsPage.js')) },
    ],
  },
];

/** ナビゲーションを付けない別ウィンドウ用の認証必須ルート。 */
export const chatStandaloneRoutes: RouteObject[] = [
  { path: '/chat/call/:meetingId', lazy: page(() => import('./pages/ChatCallPage.js')) },
];
